import dynamic from 'next/dynamic';
import 'leaflet/dist/leaflet.css';

const ClientMap = dynamic(() => import('@amf/shared/components/utils/ClientMap'), {
  ssr: false,
});

type Props = {
  title: string;
  lat: number;
  lng: number;
  zoom: number;
  width: string;
  height: string;
};

function Map(props: Props) {
  return <ClientMap {...props} />;
}

export default Map;
